import useBasket from '@hooks/basket/useBasket';
import { useCustomer } from '@hooks/customer/useCustomer';

export const useVipAccess = (): {
  vip: boolean | undefined;
  isLoading: boolean;
} => {
  const { data: customer, isLoading: isCustomerLoading } = useCustomer();
  const { data: basket, isLoading: isBasketLoading } = useBasket();

  const isLoading = isCustomerLoading || isBasketLoading;

  return {
    vip: isLoading ? undefined : customer?.vip === true || basket?.vip === true,
    isLoading,
  };
};
